import { useEffect } from 'react';

import { fabric } from 'fabric';

import { ANNOTATION_COLORS, ANNOTATION_STROKES } from '~/contexts/CanvasContext';

import { IUseFabric } from './types';

export const useTextAnnotation = (props: IUseFabric & { zoomed?: boolean; }) => {
  const { ref, context, zoomed } = props;
  const { annotationEnabled, mode, color, stroke, zoom } = context;
  const fontSize = ANNOTATION_STROKES[stroke] * 10 / (zoomed ? zoom : 1);
  useEffect(() => {
    const canvas = ref.current;
    let isSelected = false;
    let isEditing = false;
    const handleSelection = () => {
      isSelected = true;
    }
    const handleDeselection = () => {
      // time out is required to avoid adding another rectangle when clicking outside of current drawing
      setTimeout(() => {
        isSelected = false;
      }, 100);
    }
    const handleEditing = () => {
      isEditing = true;
    }
    const handleEditingExited = () => {
      // time out is required to avoid adding another text when clicking outside of text to stop editing
      setTimeout(() => {
        isEditing = false;
      }, 100);
    }
    const handleMouseUp = (event: fabric.IEvent<MouseEvent>) => {
      if (!isSelected && !isEditing && !canvas.getActiveObject()) {
        const pointer = canvas.getPointer(event.e);
        const text = new fabric.IText('Text', {
          fontFamily: 'Roboto',
          fontSize,
          left: pointer.x,
          top: pointer.y,
          fill: ANNOTATION_COLORS[color],
        });
        canvas.add(text);
        canvas.setActiveObject(text);
      }
    }

    if (annotationEnabled && mode === 'text') {
      canvas.on('mouse:up', handleMouseUp);
      canvas.on('text:editing:entered', handleEditing);
      canvas.on('text:editing:exited', handleEditingExited);
      canvas.on('selection:created', handleSelection);
      canvas.on('selection:updated', handleSelection);
      canvas.on('selection:cleared', handleDeselection);
      return () => {
        canvas.off('mouse:up', handleMouseUp);
        canvas.off('text:editing:entered', handleEditing);
        canvas.off('text:editing:exited', handleEditingExited);
        canvas.off('selection:created', handleSelection);
        canvas.off('selection:updated', handleSelection);
        canvas.off('selection:cleared', handleDeselection);
      };
    }

  }, [annotationEnabled, color, fontSize, mode, ref]);
}
